import { render, staticRenderFns } from "./BtnFirmas.vue?vue&type=template&id=2baaab53&scoped=true"
import script from "./BtnFirmas.vue?vue&type=script&lang=js"
export * from "./BtnFirmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baaab53",
  null
  
)

export default component.exports